export const LOAD_TARGET_BOWEL = 'LOAD_TARGET_BOWEL'

export const GET_ANNOTATIONS = 'GET_ANNOTATIONS'
export const GET_ANNOTATIONS_SUCCESS = 'GET_ANNOTATIONS_SUCCESS'
export const GET_ANNOTATIONS_FAILED = 'GET_ANNOTATIONS_FAILED'

export const PUT_ANNOTATION = 'PUT_ANNOTATION'
export const PUT_ANNOTATION_SUCCESS = 'PUT_ANNOTATION_SUCCESS'
export const PUT_ANNOTATION_FAILED = 'PUT_ANNOTATION_FAILED'
